import { getSourceSheetCellValue } from "@/components/Playground/Drawer/Evaluate/evaluate-drawer-utils";
import type { GridRow, SmartColumn } from "@/queries/smart-tables/types";

type ImportColumn = Pick<SmartColumn, "id" | "title">;

/** Columns named like the prompt's variables, or every column when none match. */
export const getImportColumns = <T extends ImportColumn>(
  columns: T[],
  variableNames: string[],
): T[] => {
  const names = new Set(variableNames);
  const matching = columns.filter(column => names.has(column.title));
  return matching.length > 0 ? matching : columns;
};

const formatCellValue = (value: unknown): string => {
  if (value === undefined || value === null) {
    return "";
  }
  return typeof value === "object" ? JSON.stringify(value, null, 2) : String(value);
};

export const getRowVariables = (row: GridRow, columns: ImportColumn[]): Record<string, string> =>
  Object.fromEntries(
    columns.map(column => [
      column.title,
      formatCellValue(getSourceSheetCellValue(row.cells[column.id])),
    ]),
  );
